"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ChartIcon = ({ className, width = '24', height = '24', onClick, }) => {
    return (react_1.default.createElement("div", { onClick: onClick, role: onClick ? 'button' : undefined },
        react_1.default.createElement(react_1.default.Suspense, { fallback: null },
            react_1.default.createElement("svg", { role: "img", width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "currentColor", className: className, xmlns: "http://www.w3.org/2000/svg" },
                react_1.default.createElement("path", { d: "M12 20V10", stroke: "#92ABFA", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
                react_1.default.createElement("path", { d: "M18 20V4", stroke: "#92ABFA", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
                react_1.default.createElement("path", { d: "M6 20V16", stroke: "#CBD5E1", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })))));
};
exports.default = ChartIcon;
//# sourceMappingURL=ChartIcon.js.map